import applogger from '@applogger'
let pageMixin
let asyncData

// eslint-disable-next-line no-undef
if (APPSETTINGS.DataStore.store === 'ichabodcms') {
  let prepareURL = function(requestURL, qs) {
    return requestURL
  }

  asyncData = ({ store, route }) => {
    if (!route) {
      return Promise.resolve(false)
    }
    applogger.debug('page-content-type-page asyncData starting')
    return store.dispatch('item/load', {path: route.path, type: route.type})
      .then(item => {
        if (item.attachedList.url) {
          return Promise.all([item, store.dispatch('list/load', {url: prepareURL(item.attachedList.url, { start: 0, limit: 25 })})])
        }
        else {
          return [item, null]
        }
      })
      .then(([item, attachedListItems]) => {
        applogger.debug('page-content-type-page asyncData completed')
        return {
          itemid: item.id,
          title: item.name
        }
      })
      .catch(err => {
        applogger.error('Something bad happened: ' + err.message)
      })
  }

  pageMixin = {
    computed: {
      itemid: function() { return this.item.id },
      notpublished: function() {
        return !this.item.published
      },
      attachedView: function() {
        return this.listItems.length > 0
      },
      listItems: function() {
        return this.$store.getters['list/get'](this.$route.path)
      },
      hasBody: function() {
        return (this.item.body && this.item.body.length > 0)
      },
      item: function() {
        if (this.$route.params.itemid !== undefined && !isNaN(parseFloat(this.$route.params.itemid)) && isFinite(this.$route.params.itemid)) {
          return this.$store.getters['item/getByID'](this.$route.params.type, this.$route.params.itemid)
        }
        else {
          return this.$store.getters['item/getByPath'](this.$route.path)
        }
      },
      itemComponent: function() { return this.item.attachedList.component }

    }
  }
}
else {
  asyncData = ({ store, route, router }) => {
    if (!route) {
      return Promise.resolve(false)
    }
    applogger.debug('page-content-type-page asyncData starting')
    const __loader = () => store.dispatch('node/load', {nid: route.path, type: route.type, cacheOptions: {scope: 'global'}})
      .then(node => {
        let p = []
        const blobsToLoad = [
          `page-blob-top--node-${node.nid}`,
          `page-blob-bottom--node-${node.nid}`
        ]
        p.push(store.dispatch('blob/loadgroup', {blobIDs: blobsToLoad, cacheOptions: { scope: 'global', ttl: 3600 * 12 }}))
        return Promise.all([node, Promise.all(p)])
      })
      .then(([node, loaders]) => {
        applogger.debug('page-content-type-page asyncData completed')
        return {
          itemid: node.nid,
          title: node.title
        }
      })
      .catch(err => {
        applogger.error('An error occurred loading the page.')
        switch (err.response.status) {
        case 403:
          store.commit('SET_PAGE_SETTING', { key: 'error', value: 403 })
          break
        case 404:
          store.commit('SET_PAGE_SETTING', { key: 'error', value: 404 })
          break
        default:
          store.commit('SET_PAGE_SETTING', { key: 'error', value: 500 })
          break
        }
      })

    return store.dispatch('promisePool', {
      name: `content-type-page-common--${route.path}`,
      resolve: __loader
    })
  }

  pageMixin = {
    // data: function() {
    //   return {
    //     item: null
    //   }
    // },
    // created: function() {
    //   if (this.nid === undefined) {
    //     this.item = this.$store.getters['node/getByPath'](this.$route.path)
    //   }
    //   else if (this.item === null) {
    //     asyncData({ store: this.$store })
    //       .then(_ => {
    //         this.item = this.$store.getters['node/getByPath'](this.nid)
    //       })
    //   }
    // },
    computed: {
      itemid: function() {
        return this.item ? this.item.nid : null
      },
      notpublished: function() {
        return (this.item && Object.prototype.hasOwnProperty.call(this.item, 'status')) ? (parseInt(this.item.status) !== 1) : false
      },
      attachedView: function() {
        return this.$store.getters['node/getAttachedView'](this.item.nid)
      },
      hasBody: function() {
        return (this.item.body && this.item.body.length > 0)
      },
      item: function() {
        if (this.nid !== false) {
          return this.$store.getters['node/getByNID'](this.nid)
        }
        else if (this.$route.params.nid !== undefined && !isNaN(parseFloat(this.$route.params.nid)) && isFinite(this.$route.params.nid)) {
          return this.$store.getters['node/getByNID'](this.$route.params.nid)
        }
        else {
          return this.$store.getters['node/getByPath'](this.$route.path)
        }
      },
      listItems: function() {
        return []
      }
    }
  }
}

// eslint-disable-next-line no-undef
pageMixin.computed.drupalmode = () => APPSETTINGS.DataStore.store === 'drupal'
// eslint-disable-next-line no-undef
pageMixin.computed.icmsmode = () => APPSETTINGS.DataStore.store === 'ichabodcms'

export default pageMixin
export {
  asyncData,
  pageMixin
}
